import { api } from "@/lib/axios"
import type {
  CompanyExpensesResponse,
  CreateExpensePayload,
  CreateExpenseResponse,
  ExpenseDetailResponse,
  UpdateExpensePayload,
  DeleteExpenseResponse,
} from "@/types/company-expenses"

export async function fetchCompanyExpenses(): Promise<CompanyExpensesResponse> {
  const { data } = await api.get<CompanyExpensesResponse>(
    "/admin/company-expenses/"
  )
  return data
}

export async function createCompanyExpense(
  payload: CreateExpensePayload
): Promise<CreateExpenseResponse> {
  const { data } = await api.post<CreateExpenseResponse>(
    "/admin/company-expenses/",
    payload
  )
  return data
}

export async function fetchExpenseDetail(
  id: number
): Promise<ExpenseDetailResponse> {
  const { data } = await api.get<ExpenseDetailResponse>(`/admin/expenses/${id}/`)
  return data
}

export async function updateExpense(
  id: number,
  payload: UpdateExpensePayload
): Promise<ExpenseDetailResponse> {
  const { data } = await api.patch<ExpenseDetailResponse>(
    `/admin/expenses/${id}/`,
    payload
  )
  return data
}

export async function deleteExpense(
  id: number
): Promise<DeleteExpenseResponse> {
  const { data } = await api.delete<DeleteExpenseResponse>(
    `/admin/expenses/${id}/`
  )
  return data
}

export async function createMaterialExpense(
  materialId: number,
  amount: number,
  description?: string
): Promise<CreateExpenseResponse> {
  const payload: CreateExpensePayload = {
    amount: amount.toString(),
    revenue_type: 'outcome',
    expense_type: 'material',
    description: description || null,
    material: materialId,
  }
  const { data } = await api.post<CreateExpenseResponse>(
    '/admin/company-expenses/',
    payload
  )
  return data
}
